import { GET_ALL_STORES, GET_TEMPLATE_STORES, SET_STORE_URL, SET_CURRENT_STORE, EDIT_STORE, UPDATE_STORE_EMAIL, SET_APPAREL_SIZES } from './constants';

export default {
  [GET_ALL_STORES](state, data) {
    state.list = data.map((el) => ({
      ...el,
      fullName: `${el.storeName} - ${el.storeUrl}`
    }));
  },
  [GET_TEMPLATE_STORES](state, data) {
    state.templateList = data.map((el) => ({
      ...el,
      fullName: `${el.storeName} - ${el.storeUrl}`
    }));
  },
  [SET_STORE_URL](state, data) {
    state.iframeSrc = data;
  },
  [SET_CURRENT_STORE](state, data) {
    state.store = data;
  },
  [EDIT_STORE](state, payload) {
    if (!state.store.updatesCount) state.store.updatesCount = 0;
    state.store = {
      ...state.store,
      ...payload,
      updatesCount: ++state.store.updatesCount
    };
  },
  [SET_APPAREL_SIZES](state, sizes) {
    state.apparelSizes = sizes;
  },
  [UPDATE_STORE_EMAIL](state, { storeId, field, email }) {
    if (state.store && state.store._id === storeId && state.store[field]) {
      const index = state.store[field].findIndex(item => item._id === email._id);
      if (index !== -1) {
        state.store[field].splice(index, 1, email);
      }
    }
  }
};
